import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CountryInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const country = localStorage.getItem('country');
    const countryId = country ? JSON.parse(country).countryId : null;

    if (countryId) {
      const modifiedReq = req.clone({
        setHeaders: {
          'X-Country-Id': `${countryId}`,
        },
      });
      return next.handle(modifiedReq);
    }

    return next.handle(req);
  }
}
